import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { MODAL_HIDDEN } from '@/actions/constants';
import { SavedQuery, UUID } from '@/types';
import { RootState } from '@/store';
import * as JoinMode from './joinMode';

type JoinModeModule = typeof JoinMode;

export type TJoinMode = JoinModeModule[keyof JoinModeModule];

type State = {
  mode: TJoinMode;
  selectedSavedQuerySeriesId: Maybe<SavedQuery['series']>;
};

const initialState: State = {
  mode: JoinMode.SUGGESTED,
  selectedSavedQuerySeriesId: undefined,
};

export const joinSlice = createSlice({
  name: 'joinSlice',
  initialState,
  reducers: {
    changeMode: (state, action: PayloadAction<State['mode']>) => {
      state.mode = action.payload;
    },
    setSavedQuerySeriesId: (
      state,
      action: PayloadAction<State['selectedSavedQuerySeriesId']>,
    ) => {
      state.selectedSavedQuerySeriesId = action.payload;
      state.mode = JoinMode.SAVED_QUERIES;
    },
  },
  extraReducers: {
    [MODAL_HIDDEN]: (state) => {
      state.mode = initialState.mode;
      state.selectedSavedQuerySeriesId =
        initialState.selectedSavedQuerySeriesId;
    },
  },
});

export const selectJoinMode = (state: RootState) => state.joinSlice.mode;

export const selectSavedQuerySeriesId = (state: RootState): UUID =>
  state.joinSlice.selectedSavedQuerySeriesId as UUID;

export const { changeMode, setSavedQuerySeriesId } = joinSlice.actions;
export * from './joinMode';
